import axios from 'src/api/axiosInstances/privateAxiosInstance';
import ProductSummaryList from '../types/ProductSummaryList';
import PriceSummaryInfo from '../types/PriceSummaryInfo';

export const getProductSummary = (params: ProductSummaryList.Request): Promise<ProductSummaryList.Response> => {
  return axios.get('qm/product/summary', { params });
};

export const getPriceSummaryInfo = (params: PriceSummaryInfo.Request): Promise<PriceSummaryInfo.Response> => {
  return axios.get('qm/product/pricesummaryinfo', { params });
};
